import axios from "axios";
import { TTP_WEBINAR_STATS_URL, TTP_API_STATS_URL } from "Config";
import { updateSourceToken } from "utils";

// TODO: temporaire, à remplacer par token via getState().auth.token
//var STAGING_TOKEN = "0779b8a5cff13a9627fec1c725127e29755b9252";
//var prod_TOKEN = "0b272a0ebd3c0c0325ea42b901af2248861dc571";

let fetchDeviceSourceToken;
let fetchOverviewSourceToken;
let fetchBestTrainingSourceToken;
let fetchFormatRankingSourceToken;
let fetchSpeakersSourceToken;
let fetchLocalisationSourceToken;


export const getLocalisation = function (token, issuerId, params, sourceToken) {
    fetchLocalisationSourceToken = updateSourceToken(fetchLocalisationSourceToken, sourceToken);

    const requestUrl = TTP_API_STATS_URL + "/event/stats/localisation";
    return axios.get(requestUrl, {
        cancelToken: fetchLocalisationSourceToken.token,
        headers: { "Accept": "application/json" },
        params: {
            access_token: token,
            startDate: params.startDate,
            endDate: params.endDate,
            client_id: issuerId,
        },
    });
};

export const getSpeakers = function (token, issuerId, params, sourceToken) {
    fetchSpeakersSourceToken = updateSourceToken(fetchSpeakersSourceToken, sourceToken);

    const requestUrl = TTP_API_STATS_URL + "/event/stats/speakers";
    return axios.get(requestUrl, {
        cancelToken: fetchSpeakersSourceToken.token,
        headers: { "Accept": "application/json" },
        params: {
            access_token: token,
            startDate: params.startDate,
            endDate: params.endDate,
            client_id: issuerId,
        },
    });
};


export const getFormatRanking = function (token, issuerId, params, sourceToken) {
    fetchFormatRankingSourceToken = updateSourceToken(fetchFormatRankingSourceToken, sourceToken);

    const requestUrl = TTP_API_STATS_URL + "/event/stats/format-ranking";
    return axios.get(requestUrl, {
        cancelToken: fetchFormatRankingSourceToken.token,
        headers: { "Accept": "application/json" },
        params: {
            access_token: token,
            startDate: params.startDate,
            endDate: params.endDate,
            client_id: issuerId,
        },
    });
};


export const getCategorieDevice = function (token, params, sourceToken) {
    fetchDeviceSourceToken = updateSourceToken(fetchDeviceSourceToken, sourceToken);

    const requestUrl = TTP_WEBINAR_STATS_URL + "/api/stats/catgoriedevice";
    return axios.get(requestUrl, {
        cancelToken: fetchDeviceSourceToken.token,
        headers: { "Accept": "application/json" },
        params: {
            access_token: token,
            startDate: params.startDate,
            endDate: params.endDate,
        },
    });
};

export const getStatsOverview = function (token, issuerId, params, sourceToken) {
    fetchOverviewSourceToken = updateSourceToken(fetchOverviewSourceToken, sourceToken);

    var requestUrl = TTP_API_STATS_URL + "/event/stats/overview";
    return axios.get(requestUrl, {
        cancelToken: fetchOverviewSourceToken.token,
        headers: { "Accept": "application/json" },
        params: {
            access_token: token,
            startDate: params.startDate,
            endDate: params.endDate,
            client_id: issuerId,
        },
    });
};

export const getBestTraining = function (token, issuerId, params, sourceToken) {
    fetchBestTrainingSourceToken = updateSourceToken(fetchBestTrainingSourceToken, sourceToken);

    var requestUrl = TTP_API_STATS_URL + "/event/stats/best-training";
    return axios.get(requestUrl, {
        cancelToken: fetchBestTrainingSourceToken.token,
        headers: { "Accept": "application/json" },
        params: {
            access_token: token,
            startDate: params.startDate,
            endDate: params.endDate,
            client_id: issuerId,
        },
    });
};


// WEBPACK FOOTER //
// ./app/api/TamtamAPI/webinarStats.js